import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { trackPromoClick, trackPromoShow } from './tracking';
import { openPromoDetails } from '../../actions/promoDetails';
import { LowRateMortgagePromos } from '../../components/LowRateMortgagePromos';
import { selectPage } from '../../selectors/analytics';
import { selectLowRateMortgagePromos, selectLowRateMortgageTitle } from '../../selectors/promosPage';
import { ILowRateMortgagePromo } from '../../types/promosPage';
import { createPromoProduct } from '../../utils/analytics';

export const LowRateMortgagePromosContainer = () => {
  const title = useSelector(selectLowRateMortgageTitle);
  const promoList = useSelector(selectLowRateMortgagePromos);
  const { providerIds, providerPromoIds } = React.useMemo(() => {
    return promoList.reduce(
      ({ providerIds, providerPromoIds }, { providerId, providerPromoId }) => ({
        providerIds: [...providerIds, providerId],
        providerPromoIds: [...providerPromoIds, providerPromoId],
      }),
      { providerIds: [], providerPromoIds: [] },
    );
  }, [promoList]);
  const page = useSelector(selectPage);
  const dispatch = useDispatch();

  const handlePromoShow = React.useCallback(
    () => trackPromoShow({ page, providerIds, providerPromoIds }),
    [page, providerIds, providerPromoIds],
  );

  const handlePromoClick = React.useCallback(
    (promo: ILowRateMortgagePromo) => {
      dispatch(
        openPromoDetails({
          promo: promo.popup,
          product: createPromoProduct(promo),
        }),
      );
      trackPromoClick({ page, promo });
    },
    [dispatch, page],
  );

  if (!promoList.length) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handlePromoShow} triggerOnce>
      <LowRateMortgagePromos title={title} promoList={promoList} onPromoClick={handlePromoClick} />
    </ActionAfterViewObserver>
  );
};
